export default __webpack_public_path__ + "static/media/sidebar-2.759801ca.png";